// Webpack Imports
import * as bootstrap from 'bootstrap';


(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	// Off canvas
	if (document.querySelector('#navbarSideCollapse') !== null) {
		document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
			document.body.classList.toggle("menu-expaned");
			document.querySelector('.offcanvas-collapse').classList.toggle('open');
		});
	}

	// Back to top button
	let toTopBtn = document.querySelector("#topBtn");
	let toTopWrapper = document.querySelector("#back_to_top");

	window.addEventListener("scroll", () => {
		if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
			toTopWrapper.style.opacity = 1;
		} else {
			toTopWrapper.style.opacity = 0;
		}
	})

	toTopBtn.addEventListener("click", () => {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	})
})();